export default __webpack_public_path__ + "media/file-icon.ba93f7c1.svg";